import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import FullscreenOff from 'assets/icons/fluent_page-off-fit-24-regular.svg?react';

// Slim slide header — title + exit only. Prev/Next and progress live in
// SlideFooter so the user has a single bottom-pinned place to navigate.

const Bar = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  gap: 16,
  padding: '9px 24px',
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  position: 'sticky',
  top: 0,
  background: theme.palette.primary.salad,
  zIndex: 5,
  [theme.breakpoints.down('sm')]: {
    padding: '6px 12px',
    gap: 8
  }
}));

const TitleWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 0,
  gridColumn: 2
}));

const SlideTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  lineHeight: 1.2,
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: 15
  }
}));

const RightCluster = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 8,
  gridColumn: 3
}));

const ExitButton = styled(IconButton)(({ theme }) => ({
  width: 30,
  height: 30,
  padding: 0,
  borderRadius: 8,
  color: theme.palette.grey[400],
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.black.main
  },
  '& svg': {
    width: 30,
    height: 30,
    transform: 'rotate(90deg)'
  }
}));

const SlideHeader = ({ title, onExit, exitLabel }) => {
  return (
    <Bar role="region" aria-label="Slide header">
      <TitleWrap>
        <SlideTitle variant="h2" title={title}>
          {title}
        </SlideTitle>
      </TitleWrap>

      <RightCluster>
        {onExit ? (
          <Tooltip title={exitLabel || 'Exit slide mode (Esc)'} placement="bottom" arrow>
            <ExitButton onClick={onExit} aria-label={exitLabel || 'Exit slide mode'}>
              <FullscreenOff />
            </ExitButton>
          </Tooltip>
        ) : null}
      </RightCluster>
    </Bar>
  );
};

export default SlideHeader;
